import React, { useEffect, useState } from 'react';

const QrCodeDirection = () => {
  const [redirectStatus, setRedirectStatus] = useState('Redirecting...');

  const iosAppId=""
  const androidPackageName=""
  const websiteUrl="/"
  const appScheme=null
  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
      }
      if (/android/i.test(userAgent)) {
        return 'Android';
      }
      return 'desktop';
    };

    const performRedirect = () => {
      const device = detectDevice();
      let redirectUrl;

      // Try deep linking first if app scheme is provided
      if (appScheme) {
        try {
          window.location.href = appScheme;

          // Set a fallback to the app store after a short delay
          setTimeout(() => {
            if (device === 'iOS' && iosAppId) {
              window.location.href = `https://apps.apple.com/in/app/crop-loyalty/id6503723149`;
            } else if (device === 'Android' && androidPackageName) {
              window.location.href ="https://play.google.com/store/apps/details?id=com.crop.storeapp";
            } else {
              window.location.href = websiteUrl;
            }
          }, 500);
          return;
        } catch (e) {
          console.log('Deep linking failed, redirecting to app store');
        }
      }

      // Direct store redirection
      if (device === 'iOS') {
        redirectUrl = `https://apps.apple.com/in/app/crop-loyalty/id6503723149`;
      } else if (device === 'Android') {
        redirectUrl = `https://play.google.com/store/apps/details?id=com.crop.storeapp`;
      } else {
        redirectUrl = "https://cropglobalservices.com/";
      }

      window.location.href = redirectUrl;
    };

    // Execute redirection immediately when component mounts
    performRedirect();

    // Set a timeout to update status in case redirect hangs
    const timeoutId = setTimeout(() => {
      setRedirectStatus(
        'If you are not redirected automatically, please tap anywhere on the screen.'
      );
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [iosAppId, androidPackageName, websiteUrl, appScheme]);

  // Click handler as backup
  // const handleManualRedirect = () => {
  //   const device = detectDevice();
  //   if (device === 'iOS' && iosAppId) {
  //     window.location.href = `https://apps.apple.com/in/app/crop-loyalty/id6503723149`;
  //   } else if (device === 'Android' && androidPackageName) {
  //     window.location.href = "https://play.google.com/store/apps/details?id=com.crop.storeapp";
  //   } else {
  //     window.location.href = "https://cropglobalservices.com/";
  //   }
  // };

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4 text-center"
    
    >
      <div className="animate-pulse mb-4">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
      </div>
      <p className="text-gray-700">{redirectStatus}</p>
    </div>
  );
};

export default QrCodeDirection;
